import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Button,
  ClickAwayListener,
  Fade,
  IconButton,
  Popover,
  SelectChangeEvent,
  Stack,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography,
} from "@mui/material";
import * as Sentry from "@sentry/react";
import * as yup from "yup";
import { usePopup } from '../../../../../components/newPortal/PopUpContext';
import { StudioRoleSelectionAndSavePopupModal } from '../../../../../components/newPortal/components/studioRoleSelectionAndSavePopupModal';
import ConfigWrapper from "../widget/ConfigWrapper";
import AddFilterButton, {
  CustomRadio,
  FeatureDropDown,
  FeaturesCheckbox,
  FlexInputLabel,
  NumberInput,
} from "../widget/FearturesInputTypes/FeatureInputs";
import {
  catalogueValueTypes,
  metaDataBatchPayload,
} from "../../../../../types/types";
import {
  defaultCatalogueInputValues,
  defaultCatalogueSortingConfig,
} from "../../../../defaultConfigurations/catalogueConfigDefaultValues";
import { deepClone } from "@mui/x-data-grid/utils/utils";
import { Box } from "@mantine/core";
import {
  TransformedConfig,
  configurationAttributeType,
  sortingOptions,
} from "../../../../../types";
import {
  UI_CONFIG_API_BASE_URL,
  convertValuesToConfigNew,
  createValidation,
  doFinalConfigSubmit,
  fetchMultipleUIConfigData,
  getClientConfigFilters,
  getFilters,
  getNewConfiguration,
  overWriteConfig,
  transformConfigData,
  validateMetaDataResponse,
  getStudioConfigMap,
  fetchUIConfigData
} from "../../../../../services/uiConfigService";
import {
  ChannelkartNetworkGet,
  META_DATA_BATCH_API,
} from "../../../../../services/networkService";
import { openPopup } from "../../../../../stateManagement/actions/popupActions";
import { getLob } from "../../../../../services/authenticationService";
import { updateConfigRequestBody } from "../../../../../services/managePoliciesService";
import { validateWithOtp } from "../../../../../stateManagement/actions/validateOtpPopupActions";
import { manageUpdateAccessObj } from "../../../../manageUpdateAccess/manageUpdateAccessTypes";
import { DropResult } from "react-beautiful-dnd";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import NewConfigComparePopup from "../widget/NewConfigComparePopUp";
import dropDownPreviewImage from "./static/images/dropdown-catalogue-preview.png";
import tabviewPreviewImage from "./static/images/tabview-preview.png";
import similarProductGroup from "./static/images/similar-product-preview.png";
import similarProductGroupNo from "./static/images/product-grouping-no-preview.png";
import ReloadButton from "../../../mandatoryConfigs/uiThemeConfig/widgets/reloadButton";

import {
  FeatureSelectionOptionsContext,
} from "../../../../settings/components/FeatureSelectionOptionsContext";

import {
  PlaygroundConfigValueContext,
} from "../../../../../components/newPortal/NewPortalLayout";
import ImageIcon from "@mui/icons-material/Image";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import { createBlobKey } from "../../../../../utils/utils";
import "../../mandatoryConfigCommon.css";
import Input, { CameraImage } from "../../../../../components/Input/Input";
import ResetButton from "../../../../../components/resetButton/ResetButton";
import { openPopup as triggerPopUp } from "../../../../../stateManagement/actions/popupActions";
import { Loader } from "../../../../../components/loader/Loader";
import { OptionType } from '../../../../manageHomepage/ManageHomePageTypes';
import { useSelector } from 'react-redux';
import store from '../../../../../stateManagement/store';
import { CATALOGUE_CONFIG_DOMAIN_TYPE, CATALOGUE_CONFIG_DOMAIN_TYPE3 } from "./CatalogueConstants";
import { config } from "node:process";

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    maxWidth: 260,
    border: "2px solid #909090",
    color: "grey",
    fontSize: "0.8rem",
  },
});

const Catalogue = () => {
  const currentUserData = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user;
  const designations = currentUserData?.designation ?? [];
  const {
      uiConfigOptionsProp = [],
      setUiConfigOptionsProp = () => {},
    } = useContext(FeatureSelectionOptionsContext);
  const featureDescription = uiConfigOptionsProp
    .filter((option) => option.id === "Catalogue")
    // .map((option) => option.description);
  // const PlaygroundConfigContext = useContext(PlaygroundConfigValueContext);
  // const { playgroundConfiguration, setPlayGroundConfiguration } =
  //   PlaygroundConfigContext ?? {
  //     playgroundConfiguration: [],
  //     setPlayGroundConfiguration: () => {},
  //   };
  const PlaygroundConfigContext = useContext(PlaygroundConfigValueContext);
  const {
    playgroundConfiguration,
    setPlayGroundConfiguration,
    onTriggerConfigChanges,
    keyValue,
    setKeyValue,
    cleanSyncDataLoaderIds,
    setCleanSyncDataLoaderIds,
  } = PlaygroundConfigContext ?? {
    playgroundConfiguration: [],
    setPlayGroundConfiguration: () => {},
    onTriggerConfigChanges: () => {},
    setKeyValue: () => {},
    keyValue: 0,
    cleanSyncDataLoaderIds: [],
    setCleanSyncDataLoaderIds: () => {},
  };

  const [catalogueConfig, setCatalogueConfig] = useState<
    configurationAttributeType[]
  >([]);
  const [catalogueSortingConfig, setCatalogueSortingConfig] = useState<
    configurationAttributeType<sortingOptions[]>
  >(defaultCatalogueSortingConfig.catalogueSortingConfig);
  const [values, setValues] = useState<any>(
    {}
  );
  const [defaultConfig, setDefaultConfig] = useState<any>(
    {}
  );
  const [defaultSortingConfig, setDefaultSortingConfig] = useState<any>(
    {}
  );
  const [mainCatalogueSortingConfig, setMainCatalogueSortingConfig] = useState<
  configurationAttributeType[]
>([]);
  const [sortingValues, setSortingValues] = useState<any>(
    {}
  );
    const [selectedfilterOptions, setSelectedFilterOptions] = useState<string[]>(
    []
  );
  const initialConfigMap = useRef<Record<string,any>>({});
  const savedRole: any = useSelector(() => store.getState().roleState.role);
  const savedAppType: any = useSelector(() => store.getState().appTypeState.appType);
  const { showPopup } = usePopup();
  const [loading,setLoading] = useState(true);
  const [removeConfigList,setRemoveConfigList] = useState<string[]>(
    []
  );
  const [filterValues, setFilterValues] = useState({
    filter1: "",
    filter2: "",
    filter3: "",
  });
  const CatalogueConfigDomainType = `${savedRole.id}_catalogue_configuration`;
  const CatalogueConfigDomainType2 = `${savedRole.id}_catalogue_sorting_options`;
  const getSkuCodeValueTwoToSave = (val: string) => {
    if (val === "first") {
      return "front";
    } else {
      return val;
    }
  };
  const getSkuCodeValueLabelFromSaved = (val:string)=>{
    if(val==="front"){
      return "first"
    }
    else
    {
      return val;
    }
  }
  const setupConfigState = (role: OptionType) => {
    if (!initialConfigMap.current) {
      return;
    }
    const response = initialConfigMap.current?.["clientconfig"]?.find(
      (c: any) => c?.domainType === `${role.id}_catalogue_configuration`
    ) ?? {};
    const configData = response.domainValues ?? [];
    const configObj = configData.reduce((acc: Record<string, any>, item: any) => {
    if (item?.name) {
      acc[item.name] = item;
    }
    return acc;
    }, {});
    const transformedData = transformConfigData(configObj,"catalogue_configuration");

    setValues(transformedData)
    setDefaultConfig(transformedData)
   
    
    setCatalogueConfig(configData)
    
    const response2 = initialConfigMap.current["clientconfig"]?.find(
      (c: any) => c?.domainType === `${role.id}_catalogue_sorting_options`
    ) ?? {};
    const configData2 = response2.domainValues ?? [];
    const configObj2 = configData2.reduce((acc: Record<string, any>, item: any) => {
    if (item?.name) {
      acc[item.name] = item;
    }
    return acc;
    }, {});
    const transformedData2 = transformConfigData(configObj2,"catalogue_sorting_options");
    setSortingValues(transformedData2)
    setDefaultSortingConfig(transformedData2)
     const response3 = initialConfigMap.current["clientconfig"]?.find(
      (c: any) => c?.domainType === `${role.id}_tab_filters`
    ) ?? {};
    const filters = response3.domainValues[0]?.value[0]?.value;
     
      if (filters) {
        setFilterValues({
          filter1: filters?.[0]?.name ? filters?.[0]?.name : "none",
          filter2: filters?.[1]?.name ? filters?.[1]?.name : "none",
          filter3: filters?.[2]?.name ? filters?.[2]?.name : "none",
        
        });
        const selectedfilterOptions: string[] = filters.map(
          (filter: { name: "" }) => {
            return getTitleFromValue(filter.name, filterOptions);
          }
        );
       
        setSelectedFilterOptions(selectedfilterOptions);
       
       
    setLoading(false);

  }
}
 
const requiredConfigsMap = {
  ["clientconfig"]: ["catalogue_configuration","catalogue_sorting_options","tab_filters"]
}
  const init = async () => {
    try {
      setLoading(true);
     
      const configMap = await getStudioConfigMap(requiredConfigsMap);
      initialConfigMap.current = configMap;
      setupConfigState(savedRole);
      
    } catch (error) {
      console.error("Error fetching data:",error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     setLoading(true);
    //     const response = await ChannelkartNetworkGet(
    //       `${UI_CONFIG_API_BASE_URL}/catalogue_configuration`
    //     );
    //     if (response?.status === 200) {
    //       let domainType = "catalogue_configuration"
    //       const transformedData = transformConfigData(response.data[domainType], domainType);
    //       setValues(transformedData)
    //       setDefaultConfig(transformedData)
    //       setLoading(false);
    //     }
    //     const response2 = await ChannelkartNetworkGet(
    //       `${UI_CONFIG_API_BASE_URL}/catalogue_sorting_options`
    //     );
    //     if (response2?.status === 200) {
    //       let domainType = "catalogue_sorting_options"
    //       const transformedData2 = transformConfigData(response.data[domainType], domainType);
    //       setSortingValues(transformedData2)
    //       setDefaultSortingConfig(transformedData2)
    //       setLoading(false);
    //     }
    //   }
    //    catch (error) {
    //     console.error("Error fetching data:", error);
    //     setLoading(false);
    //   }
    // };
    // fetchData();
    init();
  },[]);
  useEffect(() => {
    if (Object.keys(initialConfigMap.current || {}).length !== 0)
      setupConfigState(savedRole);
  },[savedRole])

  const [currImage,setCurrImage] = useState<string | undefined>(
    "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127589190_1726127589189-JUmJMJHwFljP.png"
  );
  const [skuCodeValueOne, setSkuCodeValueOne] = useState<string>("");
  const [skuCodeValueTwo, setSkuCodeValueTwo] = useState<string>("");
  const [skuImageCatagory, setSkuImageCatagory] = useState<string>();
  const [maxAllowedDigits, setMaxAllowedDigits] = useState<number>(
    values?.maxAllowedDigitForOrder?.value
  );
  const [catalogueValidationsSchema, setCatalogueValidationSchema] = useState(
    {}
  );
  const [uomSelectionConfiguration, setUomConfig] = useState<string>("");

  const [validationFailiure, setValidationFailiure] = useState<boolean>(false);
  const [error, setErrorDisplay] = useState<boolean>(false);
  const [infoClick, setInfoClick] = useState<boolean>(false);
  const [thirdFilter, setthirdFilter] = useState<boolean>(false);
  const [secondFilter, setsecondFilter] = useState<boolean>(false);
  
  const [sequenceType, setSequenceType] = useState({
    recomendedProduct: true,
    secondaryProduct: true,
  });
  const [hasActiveChild, setHasActiveChild] = useState(false);

  const [labelCheckValueMapping, setLabelCheckValueMapping] = useState({
    caseLabel: {
      isChecked: values?.caseUnitLabel?.loadedFromApi === true,
      value: values?.caseUnitLabel?.loadedFromApi === true ? values?.caseUnitLabel?.value : values?.focCaseUnitLabel?.value,
    },
    packLabel: {
      isChecked: values?.packUnitLabel?.loadedFromApi === true,
      value: values?.packUnitLabel?.loadedFromApi === true ? values?.packUnitLabel?.value : values?.focPackUnitLabel?.value,
    },
    otherLabel: {
      isChecked: values?.otherUnitLabel?.loadedFromApi === true,
      value: values?.otherUnitLabel?.loadedFromApi === true ? values?.otherUnitLabel?.value : values?.focOtherUnitLabel?.value,
    },
  });

  useEffect(() => {

    setLabelCheckValueMapping({
      caseLabel: {
        isChecked: values?.caseUnitLabel?.loadedFromApi === true,
        value: values?.caseUnitLabel?.loadedFromApi === true ? values?.caseUnitLabel?.value : values?.focCaseUnitLabel?.value,
      },
      packLabel: {
        isChecked: values?.packUnitLabel?.loadedFromApi === true,
        value: values?.packUnitLabel?.loadedFromApi === true ? values?.packUnitLabel?.value : values?.focPackUnitLabel?.value,
      },
      otherLabel: {
        isChecked: values?.otherUnitLabel?.loadedFromApi === true,
        value: values?.otherUnitLabel?.loadedFromApi === true ? values?.otherUnitLabel?.value : values?.focOtherUnitLabel?.value,
      },
    });
  }, [
    values?.packUnitLabel,
    values?.focPackUnitLabel,
    values?.caseUnitLabel,
    values?.focCaseUnitLabel,
    values?.otherUnitLabel,
    values?.focOtherUnitLabel,
  ]);

  useEffect(() => {
    // Check if `activeChild` exists in localStorage when the component mounts
    setHasActiveChild(!!localStorage.getItem("activeChild"));
  }, []);

  const [filterOptions, setFilterOptions] = useState([
    { value: "category", title: "Category" },
    { value: "brand", title: "Brand" },
    { value: "pieceSize", title: "Pack size" },
    { value: "subCategory", title: "Sub category" },
    { value: "flavour", title: "Flavour" },
  ]);

  const filteredOptionsLevel1 = filterOptions.filter(
    (option) =>
      option.value !== filterValues.filter2 &&
      option.value !== filterValues.filter3
  );

  const filteredOptionsLevel2 = filterOptions.filter(
    (option) =>
      option.value !== filterValues.filter1 &&
      option.value !== filterValues.filter3
  );

  const filteredOptionsLevel3 = filterOptions.filter(
    (option) =>
      option.value !== filterValues.filter2 &&
      option.value !== filterValues.filter1
  );

  const [showConfigPopup, setShowConfigPopup] = useState<boolean>(false);
  const [visibelPreviewImg, setVisiblePreviewImg] = useState<boolean>(false);
  const [filterTypePreview, setFilterTypePreview] = useState<boolean>(true);
  const curConfigRef = useRef<{ [key: string]: any[] }>({});
  const newConfigRef = useRef<{ [key: string]: any[] }>({});
  const [image, setImage] = useState();
  const [isSpinning, setIsSpinning] = useState(false);
  const [dummyImageOptions] = useState([
    {
      value:
        "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127589190_1726127589189-JUmJMJHwFljP.png",
      title: "Beverages",
    },
    {
      value:
        "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127465117_1726127465116-APWNasRoQAJm.png",
      title: "Snacks",
    },
    {
      value:
        "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127513316_1726127513316-iJPpCSrHcSRq.png",
      title: "Confectionary",
    },
    {
      value:
        "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127589190_1726127589189-JUmJMJHwFljP.png",
      title: "Stationary",
    },
    {
      value:
        "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127557972_1726127557971-CDhyrybWbrON.png",
      title: "Health & Wellness",
    },
    {
      value:
        "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127589190_1726127589189-JUmJMJHwFljP.png",
      title: "Personal Care & Hygiene",
    },
  ]);

  const lastElementRef = useRef<HTMLDivElement>(null);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  // Handle Popover close
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const getTitleFromValue = (
    value: string,
    options: typeof filterOptions
  ): string => {
    const option = options.find((option) => option.value === value);
    return option ? option.title : "";
  };

  const getCatalogueConfiguration = async () => {
    try {
      const resp = await getNewConfiguration("catalogue_configuration");
      const catalogue_config: configurationAttributeType[] = resp?.domainValues;
      let catalogueCurrentConfigs: { [key: string]: any[] } = {
        tab_filters: [],
        catalogue_configuration: [],
        catalogue_sorting_options: [],
      };

      for (let config of catalogue_config) {
        config.loadedFromApi = true;
      }

      setCatalogueConfig([...catalogue_config]);

      const sorting_config_resp = await getNewConfiguration(
        "catalogue_sorting_options"
      );
      setMainCatalogueSortingConfig([...sorting_config_resp?.domainValues])
      const filterResp = await getNewConfiguration("tab_filters");
      const filters = filterResp.domainValues[0]?.value;
      // console.log(filters);
      if (filters) {
        setFilterValues({
          filter1: filters?.[0]?.name ? filters?.[0]?.name : "none",
          filter2: filters?.[1]?.name ? filters?.[1]?.name : "none",
          filter3: filters?.[2]?.name ? filters?.[2]?.name : "none",
        });
        const selectedfilterOptions: string[] = filters.map(
          (filter: { name: "" }) => {
            return getTitleFromValue(filter.name, filterOptions);
          }
        );
        setSelectedFilterOptions(selectedfilterOptions);
      }

      const sorting_config: configurationAttributeType<sortingOptions[]>[] =
        sorting_config_resp?.domainValues;
      setCatalogueSortingConfig({ ...sorting_config[0] });

      const tabFilterConfigObj = filterResp.domainValues[0];
      catalogueCurrentConfigs.tab_filters = [tabFilterConfigObj];
      catalogueCurrentConfigs.catalogue_configuration = catalogue_config ?? [];
      catalogueCurrentConfigs.catalogue_sorting_options = sorting_config ?? [];
      curConfigRef.current = catalogueCurrentConfigs;
    } catch (err) {

      // Sentry.captureException(err);
    }
  };
  const getFilterOptions = async () => {
    try {
      const filterOptions = [
        { value: "brand", title: "Brand" },
        { value: "category", title: "Category" },
        { value: "subCategory", title: "Sub category" },
        { value: "pieceSize", title: "Pack size" },
        { value: "mrp", title: "Mrp" },
      ];
      const filteredOptions: any = [];
      for (const option of filterOptions) {
        const url = `/v1/distinctFieldData/productDetails/${option.value}`;
        const response = await ChannelkartNetworkGet(url);
        if (response && response.data) {
          const filteredData = response.data.filter((item: any) => {
            const value = item[option.value];
            return value && value !== "null" && value.trim() !== "";
          });
          if (filteredData.length > 0) {
            filteredOptions.push(option);
          }
        }
      }
      setFilterOptions(filteredOptions);
    } catch (err) {
      Sentry.captureException(err);
    }
  };

  useEffect(() => {
    getCatalogueConfiguration();
    getFilterOptions();
  }, []);

  useEffect(() => {
    const thirdFilter = filterValues?.filter3 ?? "none";
    if (values?.tabFilterType?.value === "dropdown") {
      setFilterValues({
        ...filterValues,
        filter3: "none",
      });
      setthirdFilter(false);
    }
    if (values?.tabFilterType?.value === "tabview") {
      if (thirdFilter !== "none") {
        setFilterValues({
          ...filterValues,
          filter2: thirdFilter,
          filter3: "none",
        });
      }
    }
  }, [values?.tabFilterType?.value]);

  const handleMaxPossibleDigitConfig = () => {
    setMaxAllowedDigits(
      catalogueConfig.find((e) => e.name === "maxAllowedDigitForOrder")
        ?.value ?? 3
    );
  };
  const handleDefaultCatalogueImage = () => {
    setImage(undefined);
    
    setCurrImage(
      catalogueConfig.find((e) => e.name === "defaultCatalogueImage")?.value ??
        currImage
    );

    const defaultCatalogueImage =
      catalogueConfig.find((e) => e.name === "defaultCatalogueImage")?.value ??
      null;

    if (defaultCatalogueImage) {
      setSkuImageCatagory("");
    }
  };

  useEffect(() => {
    setSkuCodeConfiguration();
  }, [values?.skuCodeCondition]);
  useEffect(() => {
    setpriceFormatterCondition();
  }, [values?.priceFormatter,loading]);

  const setpriceFormatterCondition = () => {
    let newVal = "";
    const country = localStorage.getItem("deploymentCountry");

    if (country?.toLowerCase() === "india") {
      newVal = "en_IN";
    } else {
      newVal = "en_US";
    }
    if (values?.priceFormatter?.value === "") {
      setValues({
        ...values,
        ["priceFormatter"]: {
          ...values["priceFormatter"],
          value: newVal + "-ROUND_OFF",
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      });
      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   {
      //     ...values,
      //     ["priceFormatter"]: {
      //       ...values["priceFormatter"],
      //       value: newVal + "-ROUND_OFF",
      //       isValueUpdated: true,
      //       domainType: "catalogue_configuration",
      //     },
      //   },
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    }
  };

  const setSkuCodeConfiguration = () => {
    if (values?.skuCodeCondition?.value !== "") {
      setSkuCodeValueOne(values?.skuCodeCondition?.value?.split(" ")[0]);
      setSkuCodeValueTwo(getSkuCodeValueLabelFromSaved(values?.skuCodeCondition?.value?.split(" ")[1]));
    }
  };

  useEffect(() => {
    setCatalogueConfigValues();
  }, [catalogueConfig]);

  const handleInfoIconClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setInfoClick(!infoClick);
  };

  const getValuesWithBlobKey = async () => {
    let blobKey = undefined;
    try {
      if (image) {
        blobKey = await createBlobKey([image], "admin");
        return {
          ...values,
          defaultCatalogueImage: {
            ...values?.defaultCatalogueImage,
            value: blobKey ? blobKey[0].Uri : blobKey,
            isValueUpdated: true,
          },
        };
      }
      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   {
      //     ...values,
      //   },
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
      return { ...values };
    } catch (err) {
      // Sentry.captureException(err);
      return {
        ...values,
      };
    }
  };

  const saveConfiguration = async (preview?: boolean) => {
    try {
      const resultantValues = await getValuesWithBlobKey();
      // const catalogueSchema = yup.object({ ...catalogueValidationsSchema });
      // const validationObject: any = {};
      // Object.keys(resultantValues).forEach((key) => {
      //   validationObject[key] = resultantValues[key].value;
      // });
      // await catalogueSchema.validate(validationObject);
      const { result: convertedVals, failedValidations,missingFromGlobal }  = convertValuesToConfigNew(
        resultantValues,
        catalogueConfig,
        defaultConfig
      );
      if (missingFromGlobal.length > 0) {
        const missingFromGlobalMsg = `The following configurations are not present in global configuration: ${missingFromGlobal.join(", ")}`;
        triggerPopUp("Error", `Some errors occurred while saving data.\n\n${missingFromGlobalMsg}`);
        return;
      }
      if (failedValidations.length > 0) {
        const failedKeysMessage = `The following configurations failed validation: ${failedValidations.join(", ")}`;
        triggerPopUp("Error", `Some errors occurred while saving data.\n\n${failedKeysMessage}`);
        return;
      }
      const { result: sortingConvertedVals, failedValidations: failedSortingValidations,missingFromGlobal: missingFromGlobalSorting }  = convertValuesToConfigNew(
        sortingValues,
        mainCatalogueSortingConfig,
        defaultSortingConfig
      );
      if (missingFromGlobalSorting.length > 0) {
        const missingFromGlobalMsg = `The following configurations are not present in global configuration: ${missingFromGlobal.join(", ")}`;
        triggerPopUp("Error", `Some errors occurred while saving data.\n\n${missingFromGlobalMsg}`);
        return;
      }
      if (failedSortingValidations.length > 0) {
        const failedKeysMessage = `The following configurations failed validation: ${failedValidations.join(", ")}`;
        triggerPopUp("Error", `Some errors occurred while saving data.\n\n${failedKeysMessage}`);
        return;
      }
      // todo later
      // const catalogueNewConfigs: { [key: string]: any[] } = {
      //   tab_filters: [],
      //   catalogue_configuration: [],
      //   catalogue_sorting_options: [],
      // };
      // const filteredVals = convertedVals.filter(
      //   (config) => !removeConfigList.includes(config.name)
      // );
      // newConfigRef.current = [convertedVals];
      // catalogueNewConfigs.catalogue_configuration = filteredVals ?? [];

      const newTabFilterObj = getClientConfigFilters(filterValues);
      // catalogueNewConfigs.tab_filters = newTabFilterObj;
      // catalogueNewConfigs.catalogue_sorting_options = sortingConvertedVals ?? [];
      // newConfigRef.current = catalogueNewConfigs;
      const updatedConfigMap = structuredClone(initialConfigMap.current);
      // clientconfig -> [domainTypes] ( 2 clien)
      const updatedClientConfig = updatedConfigMap["clientconfig"];
      if (Array.isArray(updatedClientConfig)) {
                  
        const clientConfigObj = updatedClientConfig.find(
        (obj: any) => obj?.domainType === `${CatalogueConfigDomainType}`
        );
                  // console.log(clientConfigObj)
        if (clientConfigObj) {
        clientConfigObj.domainValues = convertedVals;
      }
      else{
        updatedClientConfig.push({
          domainType: `${CatalogueConfigDomainType}`,
          domainValues: convertedVals,
      });
    }
    }

    if (Array.isArray(updatedClientConfig)) {
                  
        const clientConfigObj = updatedClientConfig.find(
        (obj: any) => obj?.domainType === `${CatalogueConfigDomainType2}`
        );
                  // console.log(clientConfigObj)
        if (clientConfigObj) {
        clientConfigObj.domainValues = sortingConvertedVals;
      }
      else{
        updatedClientConfig.push({
          domainType: `${CatalogueConfigDomainType2}`,
          domainValues: sortingConvertedVals,
      });
    }
    }
    if (Array.isArray(updatedClientConfig)) {
                  
        const clientConfigObj = updatedClientConfig.find(
        (obj: any) => obj?.domainType === `${savedRole.id}_${CATALOGUE_CONFIG_DOMAIN_TYPE3}`
        );
                 
        if (clientConfigObj) {
        clientConfigObj.domainValues = newTabFilterObj;
        
        
      }
      else{
        updatedClientConfig.push({
          domainType:  `${savedRole.id}_${CATALOGUE_CONFIG_DOMAIN_TYPE3}`,
          domainValues:newTabFilterObj,
        }
      );
    }
    }
    
      // const updatedDomainType = updatedClientConfig.find((cfg: Record<string,any>) => cfg.domainType === CatalogueConfigDomainType);
      // updatedDomainType.domainValues = convertedVals;
      // const updatedDomainType2 = updatedClientConfig.find((cfg: Record<string,any>) => cfg.domainType === CatalogueConfigDomainType2);
      // updatedDomainType2.domainValues = sortingConvertedVals;


      showPopup((close) => (
        <StudioRoleSelectionAndSavePopupModal
          inputData={{
            requiredConfigsMap: requiredConfigsMap,
            initialConfigMap: initialConfigMap.current,
            updatedConfigMap: updatedConfigMap,
            appType: savedAppType,
            role: savedRole,
            affectAppTypeSpecificConfig : false
          }}
          onCancel={close}
          actionPostSuccess={init}
        />
      ));
    } catch (err) {
      console.log("err===", err);
      if (err instanceof Error)
        openPopup("Error", "Error occured : " + err?.message);
    }
  };

  function getFinalMetaDataPayload() {
    const lob = getLob();
    const catalogueDataPayload: updateConfigRequestBody = {
      domainName: "clientconfig",
      domainType: "catalogue_configuration",
      domainValues: newConfigRef.current.catalogue_configuration.map(config => {
        delete config.loadedFromApi;
        return config;
      }),
      lob,
    };
    const finalMetaDataPayload: metaDataBatchPayload = {
      features: [catalogueDataPayload],
    };
    const tabFilterPayload: updateConfigRequestBody = {
      domainName: "filters",
      domainType: "tab",
      domainValues: getFilters(filterValues) as any[],
      lob,
    };
    finalMetaDataPayload.features.push(tabFilterPayload);
    const filterPayload: updateConfigRequestBody = {
      domainName: "clientconfig",
      domainType: "tab_filters",
      domainValues: getClientConfigFilters(filterValues),
      lob,
    };
    finalMetaDataPayload.features.push(filterPayload);
    if (newConfigRef.current.catalogue_sorting_options.length === 0) {
      const catalogueSortingDataPayload: updateConfigRequestBody = {
        domainName: "clientconfig",
        domainType: "catalogue_sorting_options",
        domainValues: newConfigRef.current.catalogue_sorting_options,
        lob,
      };
      finalMetaDataPayload.features.push(catalogueSortingDataPayload);
    }

    return finalMetaDataPayload;
  }
  async function doFinalCatalogueConfigSubmit() {
    const finalMetaDataPayload = getFinalMetaDataPayload();
    validateWithOtp(
      async (verifiedUser?: manageUpdateAccessObj, verifyResponse?: any) => {
        try {
          if (verifyResponse.status >= 200 || verifyResponse.status < 300) {
            const validationObj = validateMetaDataResponse(
              verifyResponse?.data?.features
            );
            if (validationObj.success) {
              openPopup("Success", "Configuration Updated");
              curConfigRef.current = { ...newConfigRef.current };
              // getCatalogueConfiguration();
            } else {
              openPopup("Error", validationObj.message);
            }
          } else {
            throw new Error("Something went wrong");
          }
        } catch (err) {
          // Sentry.captureException(err);
          if (err instanceof Error) openPopup("Error", err?.message);
        }
      },
      undefined,
      "admin",
      META_DATA_BATCH_API,
      finalMetaDataPayload,
      "PUT"
    );
    // return true;
  }

  const handleLabelValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (
      e.target.value.match("^[a-zA-Z ]*$") == null &&
      e.target.type !== "number"
    ) {
      return;
    }
    if (e.target.type === "number") {
      const digit = e.target.value === "" ? 0 : Number(e.target.value);
      if (digit < 0) {
        openPopup("Error", "Cannot set a negative value");
        return;
      }
    }

    const keyName = e.target.name;
    if (keyName === "maxAllowedDigitForOrder") {
      const digit = e.target.value === "" ? 0 : Number(e.target.value); // Use Number to convert value
      if (digit > 4) {
        openPopup("Error", "You can select Upto 4 digits for order");
        return;
      }
    }
    setValues({
      ...values,
      [keyName]: {
        ...values[keyName],
        value: e.target.value,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    });
    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     [keyName]: {
    //       ...values[keyName],
    //       value: e.target.value,
    //       isValueUpdated: true,
    //       domainType: "catalogue_configuration",
    //     },
    //   },
    //   catalogueConfig,
    //   defaultCatalogueInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  };

  const handleValueChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    newValue: number
  ) => {
    const keyName = e.target.name;

    if (keyName === "maxAllowedDigitForOrder") {
      if (newValue > 4) {
        openPopup("Error", "You can select up to 4 digits for order");
        return;
      }

      setValues((prevValues:any) => ({
        ...prevValues,
        [keyName]: {
          ...prevValues[keyName],
          value: newValue,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      }));
      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   {
      //     ...values,
      //     [keyName]: {
      //       ...values[keyName],
      //       value: newValue,
      //       isValueUpdated: true,
      //       domainType: "catalogue_configuration",
      //     },
      //   },
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    } else if (keyName === "skuCodeConditionOne") {
      if (newValue < 0) {
        openPopup("Error", "You can't set a value less than 0");
        return;
      }
      if (newValue >= 7) {
        openPopup("Error", "You can't set a value more than 6");
      }

      setSkuCodeValueOne(newValue.toString());
      setValues((prevValues:any) => ({
        ...prevValues,
        skuCodeCondition: {
          ...prevValues["skuCodeCondition"],
          value: `${newValue} ${getSkuCodeValueTwoToSave(skuCodeValueTwo)}`,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      }));
      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   {
      //     ...values,
      //     ["skuCodeCondition"]: {
      //       ...values["skuCodeCondition"],
      //       value: `${newValue} ${skuCodeValueTwo}`,
      //       isValueUpdated: true,
      //       domainType: "catalogue_configuration",
      //     },
      //   },
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    } else {
      setValues((prevValues:any) => ({
        ...prevValues,
        [keyName]: {
          ...prevValues[keyName],
          value: newValue,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      }));
      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   {
      //     ...values,
      //     [keyName]: {
      //       ...values[keyName],
      //       value: newValue,
      //       isValueUpdated: true,
      //       domainType: "catalogue_configuration",
      //     },
      //   },
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    }
  };

  const handleFilterConditionCheck = (e: SelectChangeEvent<unknown>) => {
    const keyName = e.target.name;
    setSkuCodeValueTwo(e.target.value as string);
    if (skuCodeValueOne !== "" && e.target.value !== "") {
      const value = skuCodeValueOne + " " + getSkuCodeValueTwoToSave(e.target.value as string);
      setValues({
        ...values,
        [keyName]: {
          ...values[keyName],
          value: value,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      });
      setSkuCodeValueOne(skuCodeValueOne);
      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   {
      //     ...values,
      //     [keyName]: {
      //       ...values[keyName],
      //       value: value,
      //       isValueUpdated: true,
      //       domainType: "catalogue_configuration",
      //     },
      //   },
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    }
  };

  const handleValueChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.max && e.target.value.length > parseInt(e.target.max)) return;
    if (e.target.min && e.target.value.length < parseInt(e.target.min)) {
      setValidationFailiure(true);
      setErrorDisplay(true);
    } else {
      setValidationFailiure(false);
      setErrorDisplay(false);
    }
    const { name, value } = e.target;
    const keyName = name;
    const newValue = value.toString();

    // Update the state
    setValues((prevValues:any) => ({
      ...prevValues,
      [keyName]: {
        ...prevValues[keyName],
        value: newValue,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    }));
    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     [keyName]: {
    //       ...values[keyName],
    //       value: newValue,
    //       isValueUpdated: true,
    //       domainType: "catalogue_configuration",
    //     },
    //   },
    //   catalogueConfig,
    //   defaultCatalogueInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  };

  const handleRadioChange = (e: SelectChangeEvent<unknown>) => {
    const { name, value } = e.target;
    const newValue = value === "true";

    setValues((prevValues:any) => ({
      ...prevValues,
      [name]: {
        ...prevValues[name],
        value: newValue,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    }));
    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     [name]: {
    //       ...values[name],
    //       value: newValue,
    //       isValueUpdated: true,
    //       domainType: "catalogue_configuration",
    //     },
    //   },
    //   catalogueConfig,
    //   defaultCatalogueInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  };

  const handleSelectValueChange = (e: SelectChangeEvent<unknown>) => {
    const { name, value } = e.target;

    let parsedValue: boolean | string;

    if (value === "true") {
      parsedValue = true;
    } else if (value === "false") {
      parsedValue = false;
    } else {
      parsedValue = value as string;
    }

    setValues((prevValues:any) => ({
      ...prevValues,
      [name]: {
        ...prevValues[name],
        value: parsedValue,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    }));
    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     [name]: {
    //       ...values[name],
    //       value: parsedValue,
    //       isValueUpdated: true,
    //       domainType: "catalogue_configuration",
    //     },
    //   },
    //   catalogueConfig,
    //   defaultCatalogueInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  };
  const handlePreviewVisibility = () => {
    setVisiblePreviewImg(!visibelPreviewImg);
  };

  const handleMaximumAllowedDigitIncrement = () => {
    const updatevalue = maxAllowedDigits + 1;
    setValues({
      ...values,
      maxAllowedDigitForOrder: {
        ...values?.maxAllowedDigitForOrder,
        value: updatevalue,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    });
    setMaxAllowedDigits((prev) => prev + 1);
    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     ["maxAllowedDigitForOrder"]: {
    //       ...values["maxAllowedDigitForOrder"],
    //       value: updatevalue,
    //       isValueUpdated: true,
    //       domainType: "catalogue_configuration",
    //     },
    //   },
    //   catalogueConfig,
    //   defaultCatalogueInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  };

  const handleMaximumAllowedDigitDecrement = () => {
    const updatevalue = maxAllowedDigits - 1;
    setValues({
      ...values,
      maxAllowedDigitForOrder: {
        ...values?.maxAllowedDigitForOrder,
        value: updatevalue,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    });
    setMaxAllowedDigits((prev) => prev - 1);
    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     ["maxAllowedDigitForOrder"]: {
    //       ...values["maxAllowedDigitForOrder"],
    //       value: updatevalue,
    //       isValueUpdated: true,
    //       domainType: "catalogue_configuration",
    //     },
    //   },
    //   catalogueConfig,
    //   defaultCatalogueInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  };

  const handleDummyImageChange = (e: SelectChangeEvent<unknown>) => {
    setSkuImageCatagory(e.target.value as string);

    setCurrImage(
      dummyImageOptions.filter(
        (dummyImage) => dummyImage.title === e.target.value
      )[0].value
    );
    handlePlaygroundConfig(
      dummyImageOptions.filter(
        (dummyImage) => dummyImage.title === e.target.value
      )[0].value
    );
  };

  function handlePlaygroundConfig(url: string) {
    setValues({
      ...values,
      defaultCatalogueImage: {
        ...values?.defaultCatalogueImage,
        value: url,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    });

    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     defaultCatalogueImage: {
    //       ...values?.defaultCatalogueImage,
    //       value: url,
    //     },
    //   },
    //   catalogueConfig,
    //   defaultCatalogueInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  }

  function handleRemoveFunction() {
    setImage(undefined);
    setCurrImage(undefined);
    setSkuImageCatagory("");
  }

  const handleDecimalChange = (e: SelectChangeEvent<unknown>) => {
    const keyName = e.target.name;
    let newVal = "";
    if (values?.priceFormatter?.value.split("-")[1] === "ROUND_OFF") {
      newVal = values?.priceFormatter?.value.split("-")[0] + "-WITHOUT_ROUND_OFF";
      setValues({
        ...values,
        [keyName]: {
          ...values[keyName],
          value: newVal,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      });
    } else {
      newVal = values?.priceFormatter?.value.split("-")[0] + "en_US-ROUND_OFF";
      setValues({
        ...values,
        [keyName]: {
          ...values[keyName],
          value: newVal,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      });
    }
    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     ["priceFormatter"]: {
    //       ...values["priceFormatter"],
    //       value: newVal,
    //       isValueUpdated: true,
    //       domainType: "catalogue_configuration",
    //     },
    //   },
    //   catalogueConfig,
    //   defaultCatalogueInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  };

  const handleFilterValueChange = (e: SelectChangeEvent<any>) => {
    if (e.target.name === "filter1" && filterValues.filter1 === "none") {
      setFilterValues({
        ...filterValues,
        filter1: e.target.value,
      });
    } else if (e.target.name === "filter2" && filterValues.filter1 === "none") {
      setFilterValues({
        ...filterValues,
        filter1: e.target.value,
      });
    } else
      setFilterValues({
        ...filterValues,
        [e.target.name]: e.target.value,
      });
  };

  const handleLabelCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const labelToConfigMapping: Record<
      string,
      { checked: string; unChecked: string } | undefined
    > = {
      caseLabel: {
        checked: "caseUnitLabel",
        unChecked: "focCaseUnitLabel",
      },
      packLabel: {
        checked: "packUnitLabel",
        unChecked: "focPackUnitLabel",
      },
      otherLabel: {
        checked: "otherUnitLabel",
        unChecked: "focOtherUnitLabel",
      },
    };

    const labelName = e.target.name as "caseLabel" | "packLabel" | "otherLabel";
    const isChecked = e.target.checked;

    const configMapping = labelToConfigMapping[labelName];

    if (configMapping) {
      setValues((prev:any) => {
        const checkedConfig = configMapping.checked;
        const unCheckedConfig = configMapping.unChecked;

        if (isChecked) {
          setRemoveConfigList((prevList) => {
            const updatedList = prevList.filter((config) => config !== checkedConfig);
            if (!updatedList.includes(unCheckedConfig)) {
              updatedList.push(unCheckedConfig);
            }
            return updatedList;
          });
          prev[checkedConfig] = {
            ...prev[checkedConfig],
            value: labelCheckValueMapping[labelName].value,
            isValueUpdated: true,
            domainType: "catalogue_configuration",
            loadedFromApi: true
          };
          if (unCheckedConfig) {
            prev[unCheckedConfig] = {
              ...prev[unCheckedConfig],
              value: "null",
              isValueUpdated: true,
              domainType: "catalogue_configuration",
              loadedFromApi: false
            };
          }
        } else {
          setRemoveConfigList((prevList) => {
            const updatedList = prevList.filter((config) => config !== unCheckedConfig);
            if (!updatedList.includes(checkedConfig)) {
              updatedList.push(checkedConfig);
            }
            return updatedList;
          });
          if (unCheckedConfig) {
            prev[unCheckedConfig] = {
              ...prev[unCheckedConfig],
              value: labelCheckValueMapping[labelName].value,
              isValueUpdated: true,
              domainType: "catalogue_configuration",
              loadedFromApi: true
            };
          }
          prev[checkedConfig] = {
            ...prev[checkedConfig],
            value: "null",
            isValueUpdated: true,
            domainType: "catalogue_configuration",
            loadedFromApi: false
          };
        }

        return { ...prev };
      });

      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   values,
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    }
  };

  const handleLabelUOMValueChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const labelToConfigMapping: Record<
      string,
      { checked: string; unChecked?: string; ptrConfig: string } | undefined
    > = {
      caseLabel: {
        checked: "caseUnitLabel",
        unChecked: "focCaseUnitLabel",
        ptrConfig: "casePtrLabel",
      },
      packLabel: {
        checked: "packUnitLabel",
        unChecked: "focPackUnitLabel",
        ptrConfig: "packPtrLabel",
      },
      otherLabel: {
        checked: "otherUnitLabel",
        unChecked: "focOtherUnitLabel",
        ptrConfig: "otherPtrLabel",
      },
    };

    const labelName = e.target.name as "caseLabel" | "packLabel" | "otherLabel";
    const value = e.target.value;

    if (
      e.target.value.match("^[a-zA-Z ]*$") == null &&
      e.target.type !== "number"
    ) {
      return;
    }
    if (e.target.type === "number") {
      const digit = e.target.value === "" ? 0 : Number(e.target.value);
      if (digit < 0) {
        openPopup("Error", "Cannot set a negative value");
        return;
      }
    }

    const configMapping = labelToConfigMapping[labelName];

    if (configMapping) {
      setValues((prev:any) => {
        const checkedConfig = configMapping.checked;
        const unCheckedConfig = configMapping.unChecked;
        const ptrConfig = configMapping.ptrConfig;

        if (labelCheckValueMapping[labelName].isChecked) {
          prev[checkedConfig] = {
            ...prev[checkedConfig],
            value,
            isValueUpdated: true,
            domainType: "catalogue_configuration",
          };
        } else {
          if (unCheckedConfig) {
            prev[unCheckedConfig] = {
              ...prev[unCheckedConfig],
              value,
              isValueUpdated: true,
              domainType: "catalogue_configuration",
            };
          }
        }

        prev[ptrConfig] = {
          ...prev[ptrConfig],
          value: `per ${value}`,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        };

        return { ...prev };
      });

      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   values,
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    }
  };

  const setCatalogueConfigValues = () => {
    try {
      if (catalogueConfig.length) {
        const result = { ...values };
        const resValidations = {} as {
          [key: string]: ReturnType<typeof createValidation>;
        };
        catalogueConfig.forEach((attr) => {
          resValidations[attr.name] = createValidation(attr);
          result[attr.name] = attr;
        });
        setValues({ ...result });
        setCatalogueValidationSchema({ ...resValidations });
        handleMaxPossibleDigitConfig();
        handleDefaultCatalogueImage();
      }
    } catch (err) {
      Sentry.captureException(err);
    }
  };

  useEffect(() => {
    setCatalogueConfigValues();
  }, [catalogueConfig,loading]);

  const handleFilterAdd = () => {
    if (filterValues.filter1 !== "none") {
      setsecondFilter(true);
      if (filterValues.filter2 !== "none") {
      } else if (filterValues.filter2 === "none") {
        setFilterValues({
          ...filterValues,
          filter2: filteredOptionsLevel2[0].value,
        });
      }
    }
    if (filterValues.filter2 !== "none") {
      setthirdFilter(true);
      if (filterValues.filter3 !== "none") {
      } else if (filterValues.filter3 === "none") {
        setFilterValues({
          ...filterValues,
          filter3: filteredOptionsLevel3[0].value,
        });
      }
    }
  };

  const handleFilterDelete = (filterName: string) => {
    setFilterValues((prevValues) => {
      const newValues = { ...prevValues };

      if (filterName === "filter1") {
        newValues.filter1 = newValues.filter2;
        newValues.filter2 = newValues.filter3;
        newValues.filter3 = "none";
        setsecondFilter(false);
        setthirdFilter(false);
      } else if (filterName === "filter2") {
        newValues.filter2 = newValues.filter3;
        newValues.filter3 = "none";
        setsecondFilter(false);
        setthirdFilter(false);
      } else if (filterName === "filter3") {
        newValues.filter3 = "none";
        setthirdFilter(false);
      }

      return newValues;
    });
  };
  const open = Boolean(anchorEl);
  // TODO : handle the resetting of state or make sure to initiize the state inside the function where wer are fetching the saved data
  // const resetStates = () => {
  //   ;
  //   //rather than resetting the state , the states should be initialzed with the stored value and we should reinitlaize them with the stored value by refetching the value from the db

  //   // setValues(deepClone(defaultCatalogueInputValues))
  //   // setSkuCodeValueOne("");
  //   // setSkuCodeValueTwo("");
  //   // setSkuImageCatagory(undefined);
  //   // setMaxAllowedDigits(defaultCatalogueInputValues.maxAllowedDigitForOrder?.value);
  //   // setCatalogueValidationSchema({});
  //   // // setCurrImage("https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127589190_1726127589189-JUmJMJHwFljP.png")
  //   // setCurrImage(undefined)
  //   // setImage(undefined)
  // }

  const handleReset = () => {
    getCatalogueConfiguration();
    setSkuCodeConfiguration();
    getFilterOptions();
    init();
    // resetStates();
  };
  if (loading) {
    return <div className="config-container-left "><Loader /></div>;
  }
  return (
    <div className=" config-container-left ">
      <div className="config-heading">
        <div>
          <Typography
            sx={{
              fontSize: { xs: "1rem", md: "1.2rem",lg: "1.8rem", xl: "2.2rem" },
              color: "#227C9D",
            }}
          >
            <span style={{ color: "#00C6B1", fontWeight: "bold" }}>
              CATALOGUE
            </span>
            &nbsp;CONFIGURATION
          </Typography>
          <Typography
            // marginTop={1}
            style={{ fontSize: "clamp(0.4rem, 0.8vw + 0.1rem, 1.8rem)" }}
          >
            {/* {featureDescription} */}
          </Typography>
        </div>
        <div className="uiConfig-reset-button">
          <ResetButton onReset={handleReset} buttonLabel="RESET DEFAULT" />
        </div>
      </div>

      <div
        // style={{
        //   display: "flex",
        //   marginTop: 2,
        //   padding: 18,
        //   flexDirection: "column",
        //   borderRadius: "0.6rem",
        //   height: "82%",
        //   boxShadow: "0 0px 8px rgba(0, 0, 0, 0.1)",
        // }}
        className="config-main-logic-container"
      >
        <div className="config-main">
          <ConfigWrapper
            heading="Catalogue Filter"
            customStyles={{ marginTop: "0rem" }}
          >
            <>
              <Typography marginTop={2} color={"#606060"}>
                Select the product filter type you require in the catalogue?
              </Typography>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <CustomRadio
                    label="Tab view"
                    value="tabview"
                    name="tabFilterType"
                    checked={values?.tabFilterType?.value === "tabview"}
                    onChange={(e)=>{handleSelectValueChange(e)
                      setCleanSyncDataLoaderIds((prev)=>{
                        if(prev.includes("order")){
                          return prev;
                        }
                        return [...prev,"order"]
                      })
                    }}
                    color="#909090"
                  />
                  <CustomRadio
                    label="Dropdown view"
                    value="dropdown"
                    name="tabFilterType"
                    checked={values?.tabFilterType?.value === "dropdown"}
                    onChange={(e)=>{handleSelectValueChange(e)
                      setCleanSyncDataLoaderIds((prev)=>{
                        if(prev.includes("order")){
                          return prev;
                        }
                        return [...prev,"order"]
                      })
                    }}
                    color="#909090"
                  />
                </div>
              </div>
              {filterTypePreview && (
                <div style={{ maxWidth: hasActiveChild ? "50px" : "600px" }}>
                  {values?.tabFilterType?.value === "dropdown" && (
                    <>
                      <div>
                        <img
                          style={{ maxWidth: "300px" }}
                          src={dropDownPreviewImage}
                          alt="dropDownPreview"
                        ></img>
                      </div>
                    </>
                  )}
                  {values?.tabFilterType?.value === "tabview" && (
                    <>
                      <div>
                        <img
                          style={{ maxWidth: "200px" }}
                          src={tabviewPreviewImage}
                          alt="tabViewPreview"
                        ></img>
                      </div>
                    </>
                  )}
                </div>
              )}

              <Typography marginY={2} color={"#606060"}>
                Select the Product filter you want to add:
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <div style={{ width: "15%" }}>
                  <Typography>Level 1</Typography>
                </div>
                <FeatureDropDown
                  onChange={(e)=>{handleFilterValueChange(e)
                     setCleanSyncDataLoaderIds((prev)=>{
                        if(prev.includes("order")){
                          return prev;
                        }
                        return [...prev,"order"]
                      })
                    }}
                  placeholder="Level 1"
                  value={filterValues?.filter1}
                  name="filter1"
                  options={filteredOptionsLevel1}
                  selectLableId="skuCodeCondition"
                  size="small"
                  sx={{
                    minWidth: "32%",
                    marginTop: "0.5rem",
                    marginBottom: "1rem",
                    borderRadius: "0%",
                  }}
                />
              </div>
              {!secondFilter && filterValues.filter2 === "none" ? (
                <></>
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ width: "15%" }}>
                      <Typography>Level 2</Typography>
                    </div>
                    <FeatureDropDown
                      onChange={(e)=>{handleFilterValueChange(e)
                      setCleanSyncDataLoaderIds((prev)=>{
                        if(prev.includes("order")){
                          return prev;
                        }
                        return [...prev,"order"]
                      })
                    }}
                      placeholder="Level 2"
                      value={
                        filterValues.filter2 !== "none"
                          ? filterValues.filter2
                          : filteredOptionsLevel2[0]
                      }
                      name="filter2"
                      options={filteredOptionsLevel2}
                      selectLableId="skuCodeCondition"
                      size="small"
                      sx={{
                        minWidth: "32%",
                        marginTop: "0.5rem",
                        marginBottom: "1rem",
                        borderRadius: "0%",
                      }}
                    />
                    {filterValues.filter2 !== "" && (
                      <IconButton
                        aria-label="delete"
                        size="small"
                        onClick={() =>{ handleFilterDelete("filter2")
                         setCleanSyncDataLoaderIds((prev)=>{
                        if(prev.includes("order")){
                          return prev;
                        }
                        return [...prev,"order"]
                      })
                        }
                         }
                        sx={{
                          backgroundColor: "#ffedee",
                          color: "red",
                          "&:hover": {
                            backgroundColor: "#ffedee",
                            color: "red",
                          },
                        }}
                      >
                        <RemoveOutlinedIcon style={{ fontSize: "18px" }} />
                      </IconButton>
                    )}
                  </div>
                </>
              )}
              {(thirdFilter === false && filterValues.filter3 === "none") ||
              values?.tabFilterType?.value === "dropdown" ? (
                <></>
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ width: "15%" }}>
                      <Typography>Level 3</Typography>
                    </div>
                    <FeatureDropDown
                       onChange={(e)=>{handleFilterValueChange(e)
                      setCleanSyncDataLoaderIds((prev)=>{
                        if(prev.includes("order")){
                          return prev;
                        }
                        return [...prev,"order"]
                      })
                    }}
                      placeholder="Level 3"
                      value={filterValues.filter3}
                      name="filter3"
                      options={filteredOptionsLevel3}
                      selectLableId="skuCodeCondition"
                      size="small"
                      sx={{
                        minWidth: "32%",
                        mt: 0.5,
                        mb: 1,
                        borderRadius: 0,
                      }}
                    />
                    {filterValues.filter3 !== "" && (
                      <IconButton
                        aria-label="delete"
                        size="small"
                        onClick={() =>{
                           handleFilterDelete("filter3")
                            setCleanSyncDataLoaderIds((prev)=>{
                        if(prev.includes("order")){
                          return prev;
                        }
                        return [...prev,"order"]
                      })
                        }}
                        sx={{
                          backgroundColor: "#ffedee",
                          color: "red",
                          "&:hover": {
                            backgroundColor: "#ffedee",
                            color: "red",
                          },
                        }}
                      >
                        <RemoveOutlinedIcon style={{ fontSize: "18px" }} />
                      </IconButton>
                    )}
                  </div>
                </>
              )}

              {values?.tabFilterType?.value !== "dropdown" &&
                filterValues.filter3 === "none" && (
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      width: "100%",
                      marginTop: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ width: "15%" }}>
                      <Typography>Add Filter</Typography>
                    </div>
                    <AddFilterButton onClick={
                      ()=>{
                        handleFilterAdd()
                         setCleanSyncDataLoaderIds((prev)=>{
                        if(prev.includes("order")){
                          return prev;
                        }
                        return [...prev,"order"]
                      })
                      }
                    } />
                  </div>
                )}
              {values?.tabFilterType?.value === "dropdown" &&
                filterValues.filter2 === "none" && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        width: "100%",
                        marginTop: "10px",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ width: "15%" }}>
                        <Typography>Add Filters:</Typography>
                      </div>
                      <AddFilterButton onClick={
                      ()=>{
                        handleFilterAdd()
                        setCleanSyncDataLoaderIds((prev)=>{
                        if(prev.includes("order")){
                          return prev;
                        }
                        return [...prev,"order"]
                      })
                      }
                    } />
                    </div>
                  </>
                )}
            </>
          </ConfigWrapper>
          {/* <ConfigWrapper heading="Favourite Basket">
              <>
                <Typography color={"#606060"}>
                  Allow the user to create favourite basket?
                </Typography>
                <div style={{ display: "flex", gap: "2vw" }}>
                  <CustomRadio
                    label="Yes"
                    value={true}
                    name="favouriteSKU"
                    checked={values?.favouriteSKU?.value === true}
                    onChange={handleSelectValueChange}
                    color="#909090"
                  />
                  <CustomRadio
                    label="No"
                    value={false}
                    name="favouriteSKU"
                    checked={values?.favouriteSKU?.value !== true}
                    onChange={handleSelectValueChange}
                    color="#909090"
                  />
                </div>
              </>
            </ConfigWrapper> */}
          <ConfigWrapper heading="SKU Tile">
            <Typography color={"#606060"}>Show SKU code?</Typography>
            <div style={{ display: "flex", gap: "2vw" }}>
              <CustomRadio
                label="Yes"
                checked={values?.skuCodeVisibility?.value === true}
                value="true"
                name="skuCodeVisibility"
                onChange={handleRadioChange}
              />
              <CustomRadio
                label="No"
                checked={values?.skuCodeVisibility?.value === false}
                value="false"
                name="skuCodeVisibility"
                onChange={handleRadioChange}
              />
            </div>
            {values?.skuCodeVisibility?.value && (
              <>
                <Typography color={"#606060"} marginTop={2}>
                  Select Digits of the SKU code to be visible
                </Typography>
                <Stack direction={"row"} gap={5}>
                  <FeatureDropDown
                    onChange={handleFilterConditionCheck}
                    value={skuCodeValueTwo}
                    name="skuCodeCondition"
                    options={["first", "last"]}
                    selectLableId="skuCodeCondition"
                    size="small"
                    sx={{
                      minWidth: "32%",
                      marginTop: "0.5rem",
                      marginBottom: "1rem",
                      borderRadius: "0%",
                    }}
                  />
                  <NumberInput
                    value={Number(skuCodeValueOne)}
                    onChange={(e, newValue) => handleValueChange(e, newValue)}
                    name="skuCodeConditionOne"
                    min={1}
                    max={6}
                    step={1}
                  />
                </Stack>
                <Typography
                  variant="caption"
                  sx={{
                    cursor: "pointer",
                    color: "#00C6B1",
                  }}
                >
                  upto 6 digits are allowed
                </Typography>
              </>
            )}
            <Typography marginTop={2} color={"#606060"}>
              Enable Pack size Visibility in SKU Tile
            </Typography>
            <div style={{ display: "flex", gap: "2vw" }}>
              <CustomRadio
                label="Yes"
                checked={values?.pieceSizeVisibility?.value === true}
                value="true"
                name="pieceSizeVisibility"
                onChange={handleRadioChange}
              />
              <CustomRadio
                label="No"
                checked={values?.pieceSizeVisibility?.value === false}
                value="false"
                name="pieceSizeVisibility"
                onChange={handleRadioChange}
              />
            </div>
            {values?.pieceSizeVisibility?.value && (
              <>
                <Typography color={"#606060"} marginTop={2}>
                  What should be the label for Pack size?
                </Typography>
                <Input
                  style={{ width: "50%", display: "flex" }}
                  value={values?.pieceSizeLabel?.value}
                  onChange={handleValueChangeInput}
                  name="pieceSizeLabel"
                  inputProps={{ max: 11, min: 3 }}
                />
                {error && (
                  <Typography
                    ml={"6px"}
                    style={{ color: "red", fontSize: "12px" }}
                  >{`Label must be of at least 3 characters.`}</Typography>
                )}
              </>
            )}
            <Typography marginTop={2} color={"#606060"}>
              Select the UOMs available for taking order
            </Typography>
            <Stack>
              <FeaturesCheckbox
                onChange={handleLabelCheckChange}
                checked={labelCheckValueMapping["caseLabel"].isChecked}
                name="caseLabel"
                label="Case"
              />
              <FeaturesCheckbox
                onChange={handleLabelCheckChange}
                checked={labelCheckValueMapping["packLabel"].isChecked}
                name="packLabel"
                label="Piece"
              />
              <FeaturesCheckbox
                onChange={handleLabelCheckChange}
                checked={labelCheckValueMapping["otherLabel"].isChecked}
                name="otherLabel"
                label="Other"
              />
            </Stack>
            <Typography marginTop={2} color={"#606060"}>
              Select maximum allowed digit for ordering
            </Typography>
            <div>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  marginTop: "10px",
                  marginBottom: "10px",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleMaximumAllowedDigitDecrement}
                  disabled={maxAllowedDigits <= 2}
                  style={{
                    width: "35px",
                    height: "25px",
                    minWidth: "unset",
                    color: maxAllowedDigits <= 2 ? undefined : "#00C6B2",
                    backgroundColor:
                      maxAllowedDigits <= 2 ? undefined : "#EFFDFC",
                    padding: "0",
                    fontSize: "16px",
                    lineHeight: "1",
                    borderColor: maxAllowedDigits <= 2 ? undefined : "#00C6B2",
                  }}
                >
                  -
                </Button>

                {Array.from({ length: maxAllowedDigits }).map((_, index) => (
                  <div
                    key={index}
                    style={{
                      width: "40px",
                      height: "40px",
                      border: "1px solid #1C7EA0",
                      fontWeight: "bold",
                      borderRadius: "5px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography>9</Typography>
                  </div>
                ))}

                <Button
                  variant="outlined"
                  onClick={handleMaximumAllowedDigitIncrement}
                  disabled={maxAllowedDigits >= 4}
                  style={{
                    width: "35px",
                    height: "25px",
                    minWidth: "unset",
                    color: maxAllowedDigits >= 4 ? undefined : "#00C6B2",
                    backgroundColor:
                      maxAllowedDigits >= 4 ? undefined : "#EFFDFC",
                    padding: "0",
                    fontSize: "16px",
                    lineHeight: "1",
                    borderColor: maxAllowedDigits >= 4 ? undefined : "#00C6B2",
                  }}
                >
                  +
                </Button>
              </div>
            </div>
            <Typography
              marginTop={4}
              variant="caption"
              sx={{
                cursor: "pointer",
                color: "#00C6B1",
              }}
            >
              minimum 2 and maximum 4 digits are allowed
            </Typography>
          </ConfigWrapper>
          <ConfigWrapper heading="Similar Product Grouping">
            {/* multi variant grouping */}
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography color={"#606060"}>
                  Add a similar product dropdown in the SKU tile?
                </Typography>
                <div
                  style={{
                    alignSelf: "center",
                    color: "#227C9D",
                    textDecoration: "underline",
                  }}
                  onClick={handlePreviewVisibility}
                >
                  <IconButton sx={{ color: "#227C9D" }}>
                    <ImageIcon fontSize="small" />
                  </IconButton>
                  Preview selection
                </div>
              </div>
              <div style={{ display: "flex", gap: "2vw" }}>
                <CustomRadio
                  label="Yes"
                  value={true}
                  name="multiVariantOrder"
                  checked={values?.multiVariantOrder?.value === true}
                  onChange={handleSelectValueChange}
                  color="#909090"
                />
                <CustomRadio
                  label="No"
                  value={false}
                  name="multiVariantOrder"
                  checked={values?.multiVariantOrder?.value !== true}
                  onChange={handleSelectValueChange}
                  color="#909090"
                />
              </div>
              {visibelPreviewImg && (
                <div>
                  {values?.multiVariantOrder?.value === true ? (
                    <>
                      <div>
                        <img
                          style={{ width: "400px" }}
                          src={similarProductGroup}
                          alt="similarProductGroup selected Preview"
                        ></img>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <img
                          style={{ width: "400px" }}
                          src={similarProductGroupNo}
                          alt="similarProductGroup not selected Preview"
                        ></img>
                      </div>
                    </>
                  )}
                </div>
              )}
              {values?.multiVariantOrder?.value && (
                <>
                  <Typography marginTop={2} color={"#606060"}>
                    Select the type on which the product should be grouped?
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      gap: "3vw",
                      alignItems: "baseline",
                    }}
                  >
                    <CustomRadio
                      label="Pack Size"
                      value={"pieceSize"}
                      name="multiVariantGroupingOption"
                      checked={
                        values?.multiVariantGroupingOption?.value === "pieceSize"
                      }
                      onChange={handleSelectValueChange}
                      color="#909090"
                    />

                    <div style={{ display: "flex" }}>
                      <CustomRadio
                        label="Group ID"
                        value={"groupId"}
                        name="multiVariantGroupingOption"
                        checked={
                          values?.multiVariantGroupingOption?.value === "groupId"
                        }
                        onChange={handleSelectValueChange}
                        color="#909090"
                      />
                      <IconButton
                        size="small"
                        onClick={handleInfoIconClick}
                        style={{
                          position: "relative",
                          right: "15px",
                          bottom: "8px",
                          verticalAlign: "super", // Aligns it as superscript
                          fontSize: "0.75rem", // Reduces the size if you want
                          color: "rgb(34, 124, 157)",
                        }}
                      >
                        <InfoOutlinedIcon fontSize="small" />
                      </IconButton>
                      <Popover
                        id="mouse-over-popover"
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handlePopoverClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        PaperProps={{
                          style: { padding: "10px", maxWidth: "300px" },
                        }}
                      >
                        <Typography variant="body2" color="textPrimary">
                          {/* <strong>Label:</strong> Is a unique identifier for
                            the customer's system.
                            <br />
                            <strong>Key/Code:</strong> Code which is used for
                            tracking the order in the DMS. */}
                          This particular configuration is data dependent i.e
                          will get reflected in the app if the relevant data is
                          uploaded in required format.
                        </Typography>
                      </Popover>
                      {/* <ClickAwayListener
                          onClickAway={() => setInfoClick(false)}
                        >
                          <div
                            style={{
                              alignSelf: "flex-start",
                              color: "#909090",
                              position: "relative",
                              left: "-20px",
                              top: "-4px",
                            }}
                          >
                            <CustomWidthTooltip
                              open={infoClick}
                              disableHoverListener
                              disableFocusListener
                              disableTouchListener
                              TransitionComponent={Fade}
                              TransitionProps={{ timeout: 600 }}
                              arrow
                              placement="top-start"
                              title="This particular configuration is data dependent i.e will get reflected in the app if the relevant data is uploaded in required format."
                            >
                              <IconButton onClick={handleInfoIconClick}>
                                {" "}
                                <InfoOutlinedIcon fontSize="small" />{" "}
                              </IconButton>
                            </CustomWidthTooltip>
                          </div>
                        </ClickAwayListener> */}
                    </div>
                  </div>
                </>
              )}
            </>
          </ConfigWrapper>
          <ConfigWrapper heading="Dummy Image Upload">
            <>
              <Typography color={"#606060"} marginTop={2}>
                Upload the image you wish to display when no image is available
                for the SKU
              </Typography>
              <div className="generic_form_container">
                <FeatureDropDown
                  onChange={handleDummyImageChange}
                  value={skuImageCatagory ?? "Beverages"}
                  label={
                    skuImageCatagory?.length === 0 ? "Select Category" : ""
                  }
                  name="defaultCatalogueImage"
                  selectLableId=""
                  placeholder="Select Dummy Image"
                  options={dummyImageOptions.map(
                    (imageOption) => imageOption.title
                  )}
                  size="small"
                  sx={{
                    minWidth: "32%",
                    marginTop: "0.5rem",
                    marginBottom: "1rem",
                    borderRadius: "0%",
                  }}
                />

                <CameraImage
                  image={image}
                  setImage={setImage}
                  currImage={currImage}
                  disable={skuImageCatagory ? true : false}
                  removeButton={true}
                  removeFunction={handleRemoveFunction}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    cursor: "pointer",
                    color: "#00C6B1",
                  }}
                >
                  *The image resolution should be 500x500
                </Typography>
              </div>
            </>
          </ConfigWrapper>
          <ConfigWrapper heading="Price Format">
            <>
              <div ref={lastElementRef}>
                <Typography color={"#606060"} marginTop={1}>
                  Do you want to show price with decimal ?
                </Typography>
                <div style={{ display: "flex", gap: "2vw" }}>
                  <CustomRadio
                    value={true}
                    checked={
                      values?.priceFormatter?.value.split("-")[1] !== "ROUND_OFF"
                    }
                    onChange={handleDecimalChange}
                    name="priceFormatter"
                    label="Yes"
                  />

                  <CustomRadio
                    value={false}
                    onChange={handleDecimalChange}
                    checked={
                      values?.priceFormatter?.value.split("-")[1] === "ROUND_OFF"
                    }
                    name="priceFormatter"
                    label="No"
                  />
                </div>
              </div>
            </>
          </ConfigWrapper>

          <ConfigWrapper heading="Labels">
            <>
              <Typography color={"#606060"}>
                Mention required labels:
              </Typography>
              <FlexInputLabel
                label="UOM 1 :"
                name={"caseLabel"}
                value={labelCheckValueMapping["caseLabel"].value}
                onChange={handleLabelUOMValueChange}
                placeholder=""
                max={5}
                min={3}
                onValidationFailiure={setValidationFailiure}
              />
              <FlexInputLabel
                label="UOM 2 :"
                name={"packLabel"}
                value={labelCheckValueMapping["packLabel"].value}
                onChange={handleLabelUOMValueChange}
                placeholder=""
                max={5}
                min={3}
                onValidationFailiure={setValidationFailiure}
              />
              <FlexInputLabel
                label="UOM 3 :"
                name={"otherLabel"}
                value={labelCheckValueMapping["otherLabel"].value}
                onChange={handleLabelUOMValueChange}
                placeholder=""
                max={5}
                min={3}
                onValidationFailiure={setValidationFailiure}
              />
              <FlexInputLabel
                label="MRP :"
                name={"mrpLabel"}
                value={values?.mrpLabel?.value}
                onChange={handleLabelValueChange}
                placeholder=""
                max={11}
                min={3}
                onValidationFailiure={setValidationFailiure}
              />
              {/* multi variant */}
              <FlexInputLabel
                label="Similar Product :"
                name={"multiVariantHeader"}
                value={values?.multiVariantHeader?.value}
                onChange={handleLabelValueChange}
                placeholder=""
                max={25}
                min={3}
                onValidationFailiure={setValidationFailiure} 
              />
            </>
          </ConfigWrapper>
          {designations.includes("admin") &&   <ConfigWrapper
              heading="Developer Configurations"
              isCollapsable={true}
            >
              <>
                <Typography marginTop={2} color={"#606060"}>
                  Enable Outlet Level Pricing In App
                </Typography>
                <div style={{ display: "flex", gap: "2vw" }}>
                  <CustomRadio
                    label="Yes"
                    checked={values?.outletLevelPricing?.value === true}
                    value="true"
                    name="outletLevelPricing"
                    onChange={handleRadioChange}
                  />
                  <CustomRadio
                    label="No"
                    checked={values?.outletLevelPricing?.value === false}
                    value="false"
                    name="outletLevelPricing"
                    onChange={handleRadioChange}
                  />
                </div>
                <Typography color={"#606060"} marginTop={2}>
                  What should be product Type Filter?
                </Typography>
                <Input
                  style={{ width: "50%", display: "flex" }}
                  value={values?.productTypeFilter?.value}
                  onChange={handleValueChangeInput}
                  name="productTypeFilter"
                />
                <Typography color={"#606060"} marginTop={2}>
                  What should be ssp label?
                </Typography>
                <Input
                  style={{ width: "50%", display: "flex" }}
                  value={values?.sspLabel?.value}
                  onChange={handleValueChangeInput}
                  name="sspLabel"
                />
                <Typography marginTop={2} color={"#606060"}>
                  Enable enable Edit Price In App
                </Typography>
                <div style={{ display: "flex", gap: "2vw" }}>
                  <CustomRadio
                    label="Yes"
                    checked={values?.enableEditPrice?.value === true}
                    value="true"
                    name="enableEditPrice"
                    onChange={handleRadioChange}
                  />
                  <CustomRadio
                    label="No"
                    checked={values?.enableEditPrice?.value === false}
                    value="false"
                    name="enableEditPrice"
                    onChange={handleRadioChange}
                  />
                </div>
                <Typography color={"#606060"} marginTop={2}>
                  What should Product Validation Filter?
                </Typography>
                <Input
                  style={{ width: "50%", display: "flex" }}
                  value={values?.displayProductValidationFilter?.value}
                  onChange={handleValueChangeInput}
                  name="displayProductValidationFilter"
                />
                <Typography marginTop={2} color={"#606060"}>
                  Enable Product Validation In App
                </Typography>
                <div style={{ display: "flex", gap: "2vw" }}>
                  <CustomRadio
                    label="Yes"
                    checked={values?.displayProductValidation?.value === true}
                    value="true"
                    name="displayProductValidation"
                    onChange={handleRadioChange}
                  />
                  <CustomRadio
                    label="No"
                    checked={values?.displayProductValidation?.value === false}
                    value="false"
                    name="displayProductValidation"
                    onChange={handleRadioChange}
                  />
                </div>
                <Typography marginTop={2} color={"#606060"}>
                  Enable edit Pricing functionality In App
                </Typography>
                <div style={{ display: "flex", gap: "2vw" }}>
                  <CustomRadio
                    label="Yes"
                    checked={values?.editPricing?.value === true}
                    value="true"
                    name="editPricing"
                    onChange={handleRadioChange}
                  />
                  <CustomRadio
                    label="No"
                    checked={values?.editPricing?.value === false}
                    value="false"
                    name="editPricing"
                    onChange={handleRadioChange}
                  />
                </div>
                <Typography color={"#606060"} marginTop={2}>
                  What should be default Quantity For Order?
                </Typography>
                <Input
                  style={{ width: "50%", display: "flex" }}
                  value={values?.defaultQtyForOrder?.value}
                  onChange={handleValueChangeInput}
                  name="defaultQtyForOrder"
                />
              </>
            </ConfigWrapper>}    
        </div>
        <div
          className={`config-save-button-container ${
            hasActiveChild ? "has-active-child" : ""
          }`}
        >
          <Button
            variant="contained"
            // color= "#00C6B1"
            disabled={validationFailiure}
            onClick={async () => {
              try {
                setIsSpinning(true);
                const resultantValues = await getValuesWithBlobKey();
                const { result: convertedVals, failedValidations,missingFromGlobal }  = convertValuesToConfigNew(
                  resultantValues,
                  catalogueConfig,
                  defaultConfig
                );
                if (missingFromGlobal.length > 0) {
                  const missingFromGlobalMsg = `The following configurations are not present in global configuration: ${missingFromGlobal.join(", ")}`;
                  triggerPopUp("Error", `Some errors occurred while saving data.\n\n${missingFromGlobalMsg}`);
                  setIsSpinning(false);
                  return;
                }
                if (failedValidations.length > 0) {
                  const failedKeysMessage = `The following configurations failed validation: ${failedValidations.join(", ")}`;
                  triggerPopUp("Error", `Some errors occurred while saving data.\n\n${failedKeysMessage}`);
                  setIsSpinning(false);
                  return;
                }
                const updatedVals = convertedVals.map((config) => {
                  if (removeConfigList.includes(config.name)) {
                    return { ...config, removeConfig: true };
                  }
                  return config;
                });
                setCleanSyncDataLoaderIds([]);
                setPlayGroundConfiguration(updatedVals)
                const res: any = await doFinalConfigSubmit("playground_config", updatedVals);
                // const res: any = await onTriggerConfigChanges(); // Wait for the API call to complete
                //  alert(res)
                // console.log("res is " + res);
                if (res["status"] === 200 || res["status"] === 200) {
                  setKeyValue(keyValue + 1);
                }
              } catch (error) {
                console.error("Error in onTriggerConfigChanges:", error);
              }
              setTimeout(() => {
                setIsSpinning(false);
              }, 1000);
            }}
            sx={{
              alignSelf: "flex-end",
              marginY: "1rem",
              fontSize: "clamp(0.5rem,0.9vw + 0.065rem, 1.6rem)",
              backgroundColor: "#00C6B1",
              marginRight: "10px",
            }}
          >
            PREVIEW
            {/* <div sx={{color:""}}> */}
            <ReloadButton
              isSpinning={isSpinning}
              setIsSpinning={setIsSpinning}
              // handleClick={async () =>{
              //   await onTriggerConfigChanges();
              //   setRefreshCount((prev) => prev + 1);
              // }}
              handleClick={async () => {
                try {
                  setIsSpinning(true);
                  const resultantValues = await getValuesWithBlobKey();
                  const { result: convertedVals, failedValidations,missingFromGlobal }  = convertValuesToConfigNew(
                    resultantValues,
                    catalogueConfig,
                    defaultConfig
                  );
                  if (missingFromGlobal.length > 0) {
                    const missingFromGlobalMsg = `The following configurations are not present in global configuration: ${missingFromGlobal.join(", ")}`;
                    triggerPopUp("Error", `Some errors occurred while saving data.\n\n${missingFromGlobalMsg}`);
                    setIsSpinning(false);
                    return;
                  }
                  if (failedValidations.length > 0) {
                    const failedKeysMessage = `The following configurations failed validation: ${failedValidations.join(", ")}`;
                    triggerPopUp("Error", `Some errors occurred while saving data.\n\n${failedKeysMessage}`);
                    setIsSpinning(false);
                    return;
                  }
                  const updatedVals = convertedVals.map((config) => {
                    if (removeConfigList.includes(config.name)) {
                      return { ...config, removeConfig: true };
                    }
                    return config;
                  });
                  setCleanSyncDataLoaderIds([]);
                  setPlayGroundConfiguration(updatedVals)
                  const res: any = await doFinalConfigSubmit("playground_config", updatedVals);
                  // const res: any = await onTriggerConfigChanges(); // Wait for the API call to complete
                  //  alert(res)
                  // console.log("res is " + res);
                  if (res["status"] === 200 || res["status"] === 200) {
                    setKeyValue(keyValue + 1);
                  }
                } catch (error) {
                  console.error("Error in onTriggerConfigChanges:", error);
                }
                setTimeout(() => {
                  setIsSpinning(false);
                }, 1000);
              }}
            />
            {/* </div> */}
            {/* </div> */}
          </Button>
          <Button
            variant="contained"
            disabled={validationFailiure}
            onClick={() => saveConfiguration(false)}
            sx={{
              alignSelf: "flex-end",
              marginY: "1rem",
              fontSize: "clamp(0.5rem,0.9vw + 0.065rem, 1.6rem)",
              gap:"7px"
            }}
          >
            SAVE
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg>
          </Button>
        </div>
        <NewConfigComparePopup
          message="Are you sure want to update the config"
          showConfigPopup={showConfigPopup}
          setShowConfigPopup={setShowConfigPopup}
          curConfig={curConfigRef.current}
          newConfig={newConfigRef.current}
          onSuccess={doFinalCatalogueConfigSubmit}
        />
      </div>
    </div>
  );
};

export default Catalogue;
